import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input index for product details form.
 */
export const InputProductIndex = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-index-error`,
  };

  const inputProps = {
    type: "number",
    id: `${product.sku}-input-product-index`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "Sort Order",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_INDEX,
  };

  return <Input {...parentProps} />;
};
